import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'

export const HengenixEfficacy = () => {
  return (
    <>
      {/* 1st Efficacy chart - line chart */}
      <div className='w-full rounded-xl border border-neutral200 p-4 lg:rounded-2xl lg:p-6'>
        <Text
          className='text-neutral900'
          element={'h4'}
          styleName='h4'
          value='Serplulimab Efficacy'
        />
        <Text
          className='text-neutral600'
          element={'p'}
          styleName='p'
          value='Patients demonstrated better survival rates when receiving Serplulimab than chemotherapy alone.'
        />
        <div className='mt-2 flex flex-wrap md:space-x-6 '>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-primary600' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='Serplulimab + Chemo'
            />
          </div>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-warning500' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='Chemo alone'
            />
          </div>
        </div>
        <div className='mt-2'>
          <Text
            className='text-neutral600'
            element={'p'}
            styleName='p-small'
            value='Overall Survival %'
          />
          {/* desktop image */}
          <div className='hidden md:my-2 md:block md:w-full'>
            <CloudflareImage
              alt={'Serplulimab_OS'}
              className={'object-cover'}
              height={441}
              imageId={'573a00ff-b048-4f5e-1649-6d0f6dba8200'}
              width={1600}
            />
          </div>
          {/* mobile image */}
          <div className='mt-2 block w-full md:hidden'>
            <CloudflareImage
              alt={'Serplulimab_OS'}
              className={'object-cover'}
              height={441}
              imageId={'e4d3ede9-2fe9-4c1f-81ed-b1da4ae82c00'}
              width={592}
            />
          </div>
          <div className='flex justify-center'>
            <Text
              className='text-neutral600'
              element={'p'}
              styleName='p-small'
              value='Duration of survival, month'
            />
          </div>
        </div>
      </div>

      {/* 2nd Efficacy Chart - comparison bar */}
      <div className='mt-2 w-full rounded-xl border border-neutral200 p-4 lg:rounded-2xl lg:p-6'>
        <Text
          className='text-neutral900'
          element={'h4'}
          styleName='h4'
          value='Serplulimab Efficacy'
        />
        <Text
          className='text-neutral600'
          element={'p'}
          styleName='p'
          value='Serplulimab led to >5x improvement in two year overall survival.'
        />
        {/* <div className='mt-2 flex space-x-6'>
         <div className='flex items-center'>
           <div className='mr-1 size-4 rounded-sm bg-primary600' />
           <Text
             className='text-neutral900'
             element={'p'}
             styleName='p-small'
             value='Serplulimab + Chemo'
           />
         </div>
         <div className='flex items-center'>
           <div className='mr-1 size-4 rounded-sm bg-warning500' />
           <Text
             className='text-neutral900'
             element={'p'}
             styleName='p-small'
             value='Chemo alone'
           />
         </div>
       </div> */}
        <div className='mt-2'>
          <Text
            className='text-neutral600'
            element={'p'}
            styleName='p-small'
            value='2-Year Overall Survival %'
          />

          {/* desktop image*/}
          <div className='hidden md:my-2 md:block md:w-full'>
            <CloudflareImage
              alt={'Trial Cards'}
              className={'object-cover'}
              height={444}
              imageId={'7bfe1f77-8304-44a9-530e-a407f7f87c00'}
              width={1600}
            />
          </div>

          {/* mobile image */}
          <div className='mt-2 block w-full md:hidden'>
            <CloudflareImage
              alt={'Trial Cards'}
              className={'object-cover'}
              height={441}
              imageId={'1cdcda18-b266-4572-3b92-74d9b3a52f00'}
              width={595}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export const EffectorEfficacy = () => {
  return (
    <>
      {/* 1st Efficacy chart - line chart */}
      <div className='w-full rounded-xl border border-neutral200 p-4 lg:rounded-2xl lg:p-6'>
        <Text
          className='text-neutral900'
          element={'h4'}
          styleName='h4'
          value='Tomivosertib Efficacy'
        />
        <Text
          className='text-neutral600'
          element={'p'}
          styleName='p'
          value='Tumors treated with both Tomivosertib and a Keytruda-equivalent halt all growth in mammal testing.'
        />
        <div className='mt-2 flex flex-col flex-wrap md:flex-row md:space-x-6 '>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-neutral400' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='No treatment'
            />
          </div>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-blue500' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='Keytruda-equivalent'
            />
          </div>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-primary500' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='Tomivosertib'
            />
          </div>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-warning500' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='Keytruda-eq + Tomivosertib'
            />
          </div>
        </div>
        <div className='mt-2'>
          <Text
            className='text-neutral600'
            element={'p'}
            styleName='p-small'
            value='Tumor Volume (mm³)'
          />
          {/* desktop image */}
          <div className='hidden md:my-2 md:block md:w-full'>
            <CloudflareImage
              alt={'tumor volume'}
              className={'object-cover'}
              height={450}
              imageId={'092b3659-a946-4540-f499-7999e848ac00'}
              width={1600}
            />
          </div>
          {/* mobile image */}
          <div className='mt-2 block w-full md:hidden'>
            <CloudflareImage
              alt={'tumor volume'}
              className={'object-cover'}
              height={446}
              imageId={'b876f6b2-353c-4d38-3e5f-c916e499d800'}
              width={592}
            />
          </div>
          <div className='flex justify-center'>
            <Text
              className='text-neutral600'
              element={'p'}
              styleName='p-small'
              value='Drug dosage'
            />
          </div>
        </div>
      </div>

      {/* 2nd Efficacy Chart - comparison bar */}
      <div className='mt-2 w-full rounded-xl border border-neutral200 p-4 lg:rounded-2xl lg:p-6'>
        <Text
          className='text-neutral900'
          element={'h4'}
          styleName='h4'
          value='Tomivosertib Efficacy'
        />
        <Text
          className='text-neutral600'
          element={'p'}
          styleName='p'
          value='Mice with non-small cell lung cancer live far longer when treated with Tomivosertib.'
        />
        <div className='mt-2 flex space-x-6'>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-neutral400' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='No treatment'
            />
          </div>
          <div className='flex items-center'>
            <div className='mr-1 size-4 rounded-sm bg-primary500' />
            <Text
              className='text-neutral900'
              element={'p'}
              styleName='p-small'
              value='Tomivosertib'
            />
          </div>
        </div>
        <div className='mt-2'>
          <Text
            className='text-neutral600'
            element={'p'}
            styleName='p-small'
            value='Percent Survival %'
          />

          {/* desktop image*/}
          <div className='hidden md:my-2 md:block md:w-full'>
            <CloudflareImage
              alt={'Trial Cards'}
              className={'object-cover'}
              height={444}
              imageId={'d839f735-213e-470d-baeb-7737cbba1600'}
              width={1600}
            />
          </div>

          {/* mobile image */}
          <div className='mt-2 block w-full md:hidden'>
            <CloudflareImage
              alt={'Trial Cards'}
              className={'object-cover'}
              height={446}
              imageId={'1e7e8f7a-ba8b-4c41-d56d-8628c9b1de00'}
              width={595}
            />
          </div>
          <div className='flex justify-center'>
            <Text
              className='text-neutral600'
              element={'p'}
              styleName='p-small'
              value='Days post treatment'
            />
          </div>
        </div>
      </div>
    </>
  )
}
